import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/node_modules/.pnpm/@una-ui+content@49.0.0-beta.5_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22_33f1de760399641e0d9310fb49b824a8/node_modules/@una-ui/content/layouts/default.vue").then(m => m.default || m))
}